import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";

declare var ko: any;

export class operationLogsList_template extends vnTemplate{

    public simpleFilter: filterSimple_template;
    public resultsInfo: resultsInfo_template;
    public pagination: pagination_template;

    //
    // implementation of base class [vnTemplate]
    protected getTemplateHtml(): string{

        return  `  
                <div class="sub-header w-justify">
                    <div class="w-left">
                        <div class="dropdown select-single">
                            <label for="" class="form-label">Brand</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: selectedBrandName, css: { 'is-selected': selectedTaskExecuterFilter }"></button>
                            <div class="dropdown-list">
                                <div class="column" data-bind="foreach: brands">
                                    <input name="taskExecuter_selected" type="radio" data-bind="checked : $parent.selectedBrand, value: taskExecuter,  attr: { 'id': taskExecuter }, event:{ change: $parent.onBrandSelect}">
                                    <label class="form-label" data-bind="attr: {for : taskExecuter }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="list-header w-justify">
                    <div class="w-left">
                        <h2 class="section-title">Operation Logs</h2>
                    </div>
                    <div class="w-center"> 
                        ` + this.simpleFilter.getHtmlBuild() + `
                    </div>
                    <div class="w-right"> 
                    </div>
                </div>
                
                <div data-bind="css: { loading: isLoading }">
                   <!-- ko ifnot: selectedSection() -->
                    <table class="list-results list-logs">
                        <thead>
                            <tr>
                                <th><span>Section Name</span></th>
                                <th><span>Last Modification Date</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: sections">
                            <tr class="cursor" data-bind="event: {click: $parent.onClickGetLogs }">
                                <td><span> <a data-bind="text: name"></a></span></td>
                                <td><span data-bind="text: modDate"></span></td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- /ko -->
                    <!-- ko if: selectedSection() -->
                    <div class="op-log" >
                        <div class="w-justify">
                            <div class="w-left" >
                                <button type="button" class="btn icon i-back" data-bind="if: selectedSection(), event : { click: onClickViewSections }"><span>back</span></button>
                                <h3 class="section-title" data-bind="text: selectedSection"></h3>
                                <ul data-bind="foreach: logs">
                                    <li>
                                        <button class="btn-log icon i-page" data-bind="text: $data, event: {click: $parent.onClickViewLog }, css: {'is-selected' : $data == $parent.selectedLog() }"></button>
                                    </li>
                                </ul>
                            </div>
                            <div class="w-right" >
                                <h3 class="section-title icon i-page" data-bind="text: selectedLog"></h3>
                                <p data-bind="html: logContent">
                                </p>
                            </div>
                        </div>
                    </div>            
                    <!-- /ko -->
                </div>
            `;
    }

    //
    // implementation of base class [vnTemplate]
    protected getTemplateName(): string{
        return "operationLogsList-template";
    }

    //
    // implementation of base class [vnTemplate]
    protected getMainElementClasses(): Array<string>{
        return [""];
    }

    //
    // implementation of base class [vnTemplate]
    protected initPartial(): void {

        this.simpleFilter = new filterSimple_template("simpleFilter", this.getTemplateViewModel(), this.caller);
    }

    //
    // implementation of base class [vnTemplate]
    public buildViewModel(){

        // define the viewModel data/ functions
        let self = this;

        return  {
            orderBy: ko.observable("dateLog"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("time_DESC"),

            sections: ko.observableArray([]),
            logs: ko.observableArray([]),
            labelName: ko.observable("Brand"),

            brands: ko.observableArray([]),
            selectedTaskExecuterFilter: ko.observable(),
            selectedBrand: ko.observable(),
            selectedBrandName: ko.observable(),
            selectedSection: ko.observable(),
            selectedLog: ko.observable(''),
            selectedB: ko.observable(),

            isLoading: ko.observable(),
            logContent: ko.observable(),
            onClickGetLogs : function( data, event){ self.onClickGetLogs(data); },
            onBrandSelect : function(data, event){ self.onBrandSelect(data); },
            onClickViewLog: function (data, event) { self.onClickViewLog(data); },
            onClickViewSections: function (data, event) { self.onClickViewSections(); }
        };
    }

    public getViewModelForRequest() {
        return {
            filter:{
                orderBy: this.getTemplateViewModel().orderBy()
                , orderByDirection: this.getTemplateViewModel().orderByDirection()

            }
            , filterSimple: this.simpleFilter.getViewModelForRequest()
            , filters: {
                selectedBrand:    this.getTemplateViewModel().selectedBrand(),
                selectedSection:  this.getTemplateViewModel().selectedSection(),
                selectedLog:  this.getTemplateViewModel().selectedLog(),
            }
        }

    }

    //
    // implementation of base class [vnTemplate]
    public activateLoading(){

        this.getTemplateViewModel().isLoading(1);
    }

    //
    // implementation of base class [vnTemplate]
    public deactivateLoading(){

        this.getTemplateViewModel().isLoading(0);
    }

    //
    // clicks action
    public onClickReorder(value, data, event){

        data.orderBy(value);
        if( data.orderByDirection() == "DESC" ){
            data.orderByDirection("ASC");
        }
        else{
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.reorderLogs();
    }

    public onBrandSelect(data){

        this.getTemplateViewModel().selectedBrandName(data.name);
        this.getTemplateViewModel().sections([]);
        this.getTemplateViewModel().selectedSection("")
        this.getTemplateViewModel().selectedLog("")

        this.caller.taskExecuterSelect();
    }

    //
    // set data
    public setLogs(logs): void{

        this.getTemplateViewModel().logs(logs);
    }

    public setSections(sections): void{

        this.getTemplateViewModel().sections(sections);
    }

    //
    // This function set the list of taskExecuters that can be selected
    public setBrands(brands) {

        this.getTemplateViewModel().brands(brands);
        this.getTemplateViewModel().selectedBrand(this.getTemplateViewModel().brands()[0].taskExecuter);
        this.getTemplateViewModel().selectedBrandName(this.getTemplateViewModel().brands()[0].name);
    }


    public onClickViewLog(data) {

        this.getTemplateViewModel().selectedLog(data)
        this.caller.getSectionLog();
    }

    public onClickGetLogs(data) {

        this.getTemplateViewModel().selectedSection(data.name)
        this.getTemplateViewModel().logContent("");
        this.getTemplateViewModel().selectedLog("");
        this.caller.getSectionLogs();
    }

    public setLogContent(logContent) {

        this.getTemplateViewModel().logContent(logContent);
    }

    public onClickViewSections() {

        this.getTemplateViewModel().selectedSection("")
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/operationLogsList_template.ts